export default __webpack_public_path__ + "static/media/DashboardIconWhite.d47682e9.svg";